import { render, staticRenderFns } from "./IconSvgBook.vue?vue&type=template&id=50973c65&scoped=true&"
import script from "./IconSvgBook.vue?vue&type=script&lang=js&"
export * from "./IconSvgBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50973c65",
  null
  
)

export default component.exports